module.exports = __webpack_public_path__ + "media/48.eff59dfc.mp3";